import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getAccessTokenSession } from "../../utility/common/session-store";
import {
  updateActiveProviderMachines,
  removeProviderMachines,
  updateProviderMachinesLoading,
  updateLastTime,
  updateWebsocketStatus,
} from "../../features/providerStatus/providerStatusSlice";
import { subscribe } from "diagnostics_channel";

const ProviderMachineStatus: React.FC = () => {
  const userState = useAppSelector((state: any) => state.user);
  const dispatch = useAppDispatch();

  useEffect(() => {
    let socket: WebSocket | null = null;

    try {
      const token = getAccessTokenSession();
      socket = new WebSocket(
        `${process.env.REACT_APP_WEBSOCKET_BASE_URL}event-stream/user`,
        [token]
      );

      if (userState !== undefined) {
        socket.onopen = () => {
          console.log("connected");
          dispatch(updateWebsocketStatus("connected"));
          dispatch(updateProviderMachinesLoading(true));
        };

        socket.onmessage = (event: MessageEvent) => {
          dispatch(updateProviderMachinesLoading(true));
          dispatch(updateLastTime());

          const messageData = JSON.parse(event.data);
          const { msg, type, data, hosts } = messageData;
          console.log("messageData:", messageData);
          if (messageData.data.topics && messageData.data.topics.length !== 0) {
            let sendData: any = {
              action: "subscribe",
              data: { topics: messageData.data.topics },
            };
            socket?.send(JSON.stringify(sendData));
          }

          if (type === "host.live_report.reported") {
            // gets subscribe data from the websocket
            dispatch(updateProviderMachinesLoading(false));
            dispatch(updateLastTime());
            dispatch(updateActiveProviderMachines(data.host_live_report));
          } else if (msg === "success") {
            // might get deprecated but saved for right now
            dispatch(updateWebsocketStatus("success"));
            dispatch(updateProviderMachinesLoading(false));
            dispatch(updateLastTime());
            dispatch(updateActiveProviderMachines(hosts));
          }
        };

        socket.onclose = () => {
          console.log("WebSocket disconnected");
          dispatch(updateProviderMachinesLoading(false));
          dispatch(updateWebsocketStatus("closed"));
        };

        socket.onerror = (error) => {
          dispatch(updateProviderMachinesLoading(false));
          dispatch(updateWebsocketStatus("error"));
          dispatch(removeProviderMachines());
          console.error("WebSocket error:", error);
        };
      }
    } catch (err) {
      console.warn("WebSocket not initialized due to missing token:", err);
      // Optional: redirect to login or show error
    }

    return () => {
      if (socket) {
        socket.close();
      }
    };
  }, [userState, dispatch]);

  return <div></div>;
};

export default ProviderMachineStatus;
